import { EMPTY_LIST } from '../../../../../constants/common'

import {
  LISTING_APPLICANT_ACTION_OPEN,
  LISTING_APPLICANT_ROW_ACTIONS,
} from './RentalPortalListingProfileApplicants.constants'

export function getListingApplicantItemActions(item) {
  return item?.permissions?.can_view
    ? LISTING_APPLICANT_ROW_ACTIONS
    : EMPTY_LIST
}

export function getIsListingApplicantsEmpty({ hasError, isInitiated, items }) {
  const isLoaded = isInitiated && !hasError

  return isLoaded && items.length === 0
}

export function getIsListingApplicantActionOpen(action) {
  return action === LISTING_APPLICANT_ACTION_OPEN
}
